import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectTextFragment = createSelector(
  (state: RootState) => state.accordion.textFragment,
  textFragment => textFragment
)

export default selectTextFragment
